import PropTypes from 'prop-types'
import styled from 'styled-components'

import Button from 'components/Shared/Button/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import { uniqueId } from 'utils/strings'

const StyledWrapper = styled.div`
  display: inline-flex;
  width: ${props => props.useFullWidth ? '100%' : 'initial'};

  button {
    border-radius: 0;
    padding: 0 16px;
    min-width: initial;
    flex: ${props => props.useFullWidth ? '1' : 'initial'};
  }

  & > :first-child {
    border-radius: 3px 0 0 3px;
  }

  & > :last-child {
    border-radius: 0 3px 3px 0;
  }
`

const ToggleButtonGroup = ({ value, buttons, onChange, className, disabled, useFullWidth }) => {
  const onKeyDown = (e) => {
    if (['ArrowLeft', 'ArrowRight'].includes(e.key)) {
      // convert children from HTMLCollection to Array to use indexOf()
      const focusedIndex = Array.from(e.target.parentNode.children).indexOf(e.target)

      const newValueIndex = (focusedIndex + (e.key === 'ArrowLeft' ? -1 : 1) + buttons.length) % buttons.length
      e.target.parentNode.children[newValueIndex].focus()
      e.preventDefault()
    }
  }

  const tooltipId = 'tbg_tooltip_' + uniqueId()

  return (
    <>
      <Tooltip id={tooltipId} />
      <StyledWrapper
        className={className}
        disabled={disabled}
        onKeyDown={onKeyDown}
        tabIndex='-1'
        useFullWidth={useFullWidth}
      >
        {buttons.map(button => {
          const isActive = Boolean(value === button.value)

          return (
            <Button
              key={button.value}
              onClick={() => onChange(button.value)}
              active={isActive}
              data-tooltip-content={button.tooltip}
              data-tooltip-id={tooltipId}
              data-test={button.value}
              alert={button.buttonType === 'alert'}
              success={button.buttonType === 'success'}
              paused={button.buttonType === 'paused'}
              disabled={disabled || button.disabled}
              iconName={button.iconName}
            >
              {button.label}
            </Button>
          )
        })}
      </StyledWrapper>
    </>
  )
}

ToggleButtonGroup.propTypes = {
  value: PropTypes.string,
  buttons: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  useFullWidth: PropTypes.bool,
}

export default ToggleButtonGroup
